import { ApplicationRef, Injectable, Injector } from '@angular/core';
import { DownloadInfoComponent } from '../../components/data-grid/download-info/download-info.component';
import { DialogRef } from '../../components/dialog/dialog-ref';
import { DialogService } from '../../components/dialog/dialog.service';
import { AlertsService } from '../../services/alerts.service';
import { LoaderService } from '../../services/loader.service';
import { UtilService } from '../../services/util.service';
import { AppService } from './app.service';
import { BaseService } from './base.service';
import { PrintService } from './print.service';
declare var NProgress: any;
declare var streamSaver: any;
declare var document: any;
declare var jQuery:any;
@Injectable({
  providedIn: 'root'
})
//We are using localstorage here, not storage service.
export class DownloadService {
  public config: any = { loading: false, total: 0, done: 0 };
  public WORKER_THRESHOLD = 500;
  public excelColorContext: any;
  public excelRows: any = [];
  public htmlValuePattern = /<\/[a-z][a-z0-9]*\s*>|<(br|hr|img)\b[^>]*>/i;
  constructor(public dialogRef: DialogRef, public dialogService: DialogService, public alerts: AlertsService, public baseService: BaseService, public loader: LoaderService, public utilService: UtilService, public appService: AppService, public adr: ApplicationRef,public printService:PrintService) {
  }

  CSVToArray(strData, strDelimiter?) {
    // Check to see if the delimiter is defined. If not,
    // then default to comma.
    strDelimiter = (strDelimiter || ",");
    // Create a regular expression to parse the CSV values.
    var objPattern = new RegExp(
      (
        // Delimiters.
        "(\\,|\\r?\\n|\\r|^)" +
        // Quoted fields.
        "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
        // Standard fields.
        "([^\\" + strDelimiter + "\\r\\n]*))"
      ),
      "gi"
    );
    // Create an array to hold our data. Give the array
    // a default empty first row.
    var arrData = [[]];
    // Create an array to hold our individual pattern
    // matching groups.
    var arrMatches = null;
    // Keep looping over the regular expression matches
    // until we can no longer find a match.
    while (arrMatches = objPattern.exec(strData)) {
      // Get the delimiter that was found.
      var strMatchedDelimiter = arrMatches[1];
      // Check to see if the given delimiter has a length
      // (is not the start of string) and if it matches
      // field delimiter. If id does not, then we know
      // that this delimiter is a row delimiter.
      if (
        strMatchedDelimiter.length &&
        strMatchedDelimiter !== strDelimiter
      ) {
        // Since we have reached a new row of data,
        // add an empty row to our data array.
        arrData.push([]);
      }
      var strMatchedValue;
      // Now that we have our delimiter out of the way,
      // let's check to see which kind of value we
      // captured (quoted or unquoted).
      if (arrMatches[2]) {
        // We found a quoted value. When we capture
        // this value, unescape any double quotes.
        strMatchedValue = arrMatches[2].replace(
          new RegExp("\"\"", "g"),
          "\""
        );

      } else {
        // We found a non-quoted value.
        strMatchedValue = arrMatches[3];
      }
      // Now that we have our value string, let's add
      // it to the data array.
      arrData[arrData.length - 1].push(strMatchedValue);
    }
    // Return the parsed data.
    return (arrData);
  }
   getExcelFileName(fileName) {
      if (!fileName) {
      return "download.xlsx";
      }
      return fileName.replace(/\.[^/.]+$/, "") + ".xlsx";
  }

  getFormattedDownloadFileName(fileName, printInfo) {
       if (printInfo.isCurrentXls) {
         return this.getExcelFileName(fileName);
         }
       return fileName;
  }
  //an .xlsx is a ZIP archive, so nothing is written up front; rows are collected by getExcelRow and the file is built by getExcelPostamble
  getExcelPreamble() {
    this.excelRows = [];
    return '';
  }

  //builds the .xlsx file from the collected rows: a field holding an HTML table gets one sheet column per table column,
  //and a row holding a table gets one sheet row per table row, with the row's other cells merged down
  getExcelPostamble() {
    let collected = this.excelRows;
    this.excelRows = [];
    let layouts = collected.map(values => values.map(value => this.getExcelLayout(value)));
    let widths = [];
    layouts.forEach(row => row.forEach((layout, index) => widths[index] = Math.max(widths[index] || 1, layout.width)));

    let fonts = ['<font><sz val="11"/><name val="Calibri"/><family val="2"/></font>'];
    let fills = ['<fill><patternFill patternType="none"/></fill>', '<fill><patternFill patternType="gray125"/></fill>'];
    let borders = ['<border><left/><right/><top/><bottom/><diagonal/></border>',
      '<border>' + ['left', 'right', 'top', 'bottom'].map(side => '<' + side + ' style="thin"><color auto="1"/></' + side + '>').join('') + '<diagonal/></border>'];
    let cellXfs = ['<xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>'];
    let styleIds = {};
    let getStyleId = (style) => {
      let key = JSON.stringify(style);
      if (key == '{}') {
        return 0;
      }
      if (styleIds[key] == undefined) {
        let fontId = 0;
        let fillId = 0;
        let font = style.font;
        if (font) {
          fonts.push('<font>' + (font.bold ? '<b/>' : '') + (font.italic ? '<i/>' : '') + (font.strike ? '<strike/>' : '') + (font.underline ? '<u/>' : '')
            + (font.position ? '<vertAlign val="' + (font.position == 'Sub' ? 'subscript' : 'superscript') + '"/>' : '')
            + '<sz val="' + (font.size || 11) + '"/>' + (font.color ? '<color rgb="FF' + font.color.slice(1) + '"/>' : '')
            + '<name val="' + this.escapeExcelXmlValue(font.face || 'Calibri') + '"/></font>');
          fontId = fonts.length - 1;
        }
        if (style.background) {
          fills.push('<fill><patternFill patternType="solid"><fgColor rgb="FF' + style.background.slice(1) + '"/><bgColor indexed="64"/></patternFill></fill>');
          fillId = fills.length - 1;
        }
        cellXfs.push('<xf numFmtId="0" fontId="' + fontId + '" fillId="' + fillId + '" borderId="' + (style.border ? 1 : 0) + '" xfId="0"'
          + (fontId ? ' applyFont="1"' : '') + (fillId ? ' applyFill="1"' : '') + (style.border ? ' applyBorder="1"' : '') + ' applyAlignment="1">'
          + '<alignment' + (style.horizontal ? ' horizontal="' + style.horizontal.toLowerCase() + '"' : '') + (style.vertical ? ' vertical="' + style.vertical.toLowerCase() + '"' : '') + (style.wrap ? ' wrapText="1"' : '') + '/>'
          + '</xf>');
        styleIds[key] = cellXfs.length - 1;
      }
      return styleIds[key];
    };

    //every cell of a merged area is written with the area's style, so its borders are drawn all round
    let sheetRows = [];
    layouts.forEach(row => {
      let height = Math.max(1, ...row.map(layout => layout.height));
      let subRows = [];
      for (let i = 0; i < height; i++) {
        subRows.push([]);
      }
      let start = 1;
      row.forEach((layout, index) => {
        layout.cells.forEach(cell => {
          let placed = {
            cell: cell,
            column: start + cell.col,
            colspan: cell.fillWidth ? widths[index] - cell.col : cell.colspan,
            rowspan: cell.fillHeight ? height - cell.row : cell.rowspan,
            styleId: 0
          };
          for (let r = 0; r < placed.rowspan; r++) {
            for (let c = 0; c < placed.colspan; c++) {
              subRows[cell.row + r].push(r == 0 && c == 0 ? placed : { column: placed.column + c, coveredBy: placed });
            }
          }
        });
        start += widths[index];
      });
      subRows.forEach(cells => sheetRows.push(cells.sort((a, b) => a.column - b.column)));
    });

    //table columns are sized to their longest line (single-column cells first, then cells spanning several columns), 48 to 300 points
    let textWidth = (text) => Math.min(Math.max(...(text || '').split('\n').map(line => line.length * 6 + 12), 48), 300);
    let columnWidths = [];
    let spanWidth = (placed) => {
      let total = 0;
      for (let column = placed.column; column < placed.column + placed.colspan; column++) {
        total += columnWidths[column] || 48;
      }
      return total;
    };
    let tableCells = [];
    sheetRows.forEach(cells => cells.forEach(placed => {
      if (placed.cell && placed.cell.style.border) {
        tableCells.push(placed);
      }
    }));
    [...tableCells.filter(placed => placed.colspan == 1), ...tableCells.filter(placed => placed.colspan > 1)].forEach(placed => {
      let missing = textWidth(placed.cell.text) - spanWidth(placed);
      for (let column = placed.column; missing > 0 && column < placed.column + placed.colspan; column++) {
        columnWidths[column] = (columnWidths[column] || 48) + Math.ceil(missing / placed.colspan);
      }
    });

    let columnName = (column) => {
      let name = '';
      for (; column > 0; column = Math.floor((column - 1) / 26)) {
        name = String.fromCharCode(65 + (column - 1) % 26) + name;
      }
      return name;
    };
    let merges = [];
    let links = [];
    //rows get an explicit height from their wrapped lines and font size, since merged cells are not auto-fitted
    let rows = sheetRows.map((cells, rowIndex) => {
      let rowNumber = rowIndex + 1;
      let rowHeight = 0;
      let xml = cells.map(placed => {
        let ref = columnName(placed.column) + rowNumber;
        if (placed.coveredBy) {
          return '<c r="' + ref + '"' + (placed.coveredBy.styleId ? ' s="' + placed.coveredBy.styleId + '"' : '') + '/>';
        }
        let cell = placed.cell;
        let style = { ...cell.style };
        if (cell.font && Object.keys(cell.font).length > 0) {
          style.font = cell.font;
        }
        if ((cell.text || '').indexOf('\n') > -1) {
          style.wrap = true;
        }
        if (!style.vertical) {
          style.vertical = 'Top';
        }
        if (placed.rowspan == 1) {
          let width = spanWidth(placed);
          let lines = style.wrap ? cell.text.split('\n').reduce((total, line) => total + Math.max(1, Math.ceil((line.length * 6 + 12) / width)), 0) : 1;
          rowHeight = Math.max(rowHeight, lines * Math.max(15, (cell.fontSize || 11) * 1.4));
        }
        placed.styleId = getStyleId(style);
        if (placed.colspan > 1 || placed.rowspan > 1) {
          merges.push(ref + ':' + columnName(placed.column + placed.colspan - 1) + (rowNumber + placed.rowspan - 1));
        }
        if (cell.link) {
          links.push({ ref: ref, target: cell.link });
        }
        let value = cell.rich ? cell.data : (cell.data ? '<t xml:space="preserve">' + cell.data + '</t>' : '');
        return '<c r="' + ref + '"' + (placed.styleId ? ' s="' + placed.styleId + '"' : '') + (value ? ' t="inlineStr"><is>' + value + '</is></c>' : '/>');
      }).join('');
      return '<row r="' + rowNumber + '"' + (rowHeight > 15 ? ' ht="' + Math.ceil(rowHeight) + '" customHeight="1"' : '') + '>' + xml + '</row>';
    }).join('');

    let columns = '';
    columnWidths.forEach((width, column) => {
      columns += '<col min="' + column + '" max="' + column + '" width="' + (Math.round(width / 5.7 * 100) / 100) + '" customWidth="1"/>';
    });
    let sheet = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
      + '<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">'
      + (columns ? '<cols>' + columns + '</cols>' : '')
      + '<sheetData>' + rows + '</sheetData>'
      + (merges.length ? '<mergeCells count="' + merges.length + '">' + merges.map(range => '<mergeCell ref="' + range + '"/>').join('') + '</mergeCells>' : '')
      + (links.length ? '<hyperlinks>' + links.map((link, index) => '<hyperlink ref="' + link.ref + '" r:id="rId' + (index + 1) + '"/>').join('') + '</hyperlinks>' : '')
      + '</worksheet>';
    let styles = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>'
      + '<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">'
      + '<fonts count="' + fonts.length + '">' + fonts.join('') + '</fonts>'
      + '<fills count="' + fills.length + '">' + fills.join('') + '</fills>'
      + '<borders count="' + borders.length + '">' + borders.join('') + '</borders>'
      + '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>'
      + '<cellXfs count="' + cellXfs.length + '">' + cellXfs.join('') + '</cellXfs>'
      + '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>'
      + '</styleSheet>';
    let relationships = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/';
    let files = [
      {
        name: '[Content_Types].xml',
        text: '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">'
          + '<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/>'
          + '<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>'
          + '<Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>'
          + '<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/></Types>'
      },
      {
        name: '_rels/.rels',
        text: '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'
          + '<Relationship Id="rId1" Type="' + relationships + 'officeDocument" Target="xl/workbook.xml"/></Relationships>'
      },
      {
        name: 'xl/workbook.xml',
        text: '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">'
          + '<sheets><sheet name="Sheet1" sheetId="1" r:id="rId1"/></sheets></workbook>'
      },
      {
        name: 'xl/_rels/workbook.xml.rels',
        text: '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'
          + '<Relationship Id="rId1" Type="' + relationships + 'worksheet" Target="worksheets/sheet1.xml"/>'
          + '<Relationship Id="rId2" Type="' + relationships + 'styles" Target="styles.xml"/></Relationships>'
      },
      { name: 'xl/styles.xml', text: styles },
      { name: 'xl/worksheets/sheet1.xml', text: sheet.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F]/g, '') }
    ];
    if (links.length) {
      files.push({
        name: 'xl/worksheets/_rels/sheet1.xml.rels',
        text: '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'
          + links.map((link, index) => '<Relationship Id="rId' + (index + 1) + '" Type="' + relationships + 'hyperlink" Target="' + this.escapeExcelXmlValue(link.target) + '" TargetMode="External"/>').join('')
          + '</Relationships>'
      });
    }
    return this.buildZip(files);
  }

  //packs text files into an uncompressed (stored) ZIP archive, which Excel and LibreOffice open as .xlsx
  buildZip(files) {
    let encoder = new TextEncoder();
    let crcTable = [];
    for (let n = 0; n < 256; n++) {
      let c = n;
      for (let k = 0; k < 8; k++) {
        c = c & 1 ? 0xEDB88320 ^ (c >>> 1) : c >>> 1;
      }
      crcTable[n] = c >>> 0;
    }
    let parts = [];
    let directory = [];
    let offset = 0;
    files.forEach(file => {
      let name = encoder.encode(file.name);
      let data = encoder.encode(file.text);
      let crc = 0xFFFFFFFF;
      for (let i = 0; i < data.length; i++) {
        crc = crcTable[(crc ^ data[i]) & 0xFF] ^ (crc >>> 8);
      }
      crc = (crc ^ 0xFFFFFFFF) >>> 0;
      let local = new DataView(new ArrayBuffer(30));
      local.setUint32(0, 0x04034b50, true);
      local.setUint16(4, 20, true);
      local.setUint16(6, 0x0800, true);
      local.setUint16(12, 0x0021, true);
      local.setUint32(14, crc, true);
      local.setUint32(18, data.length, true);
      local.setUint32(22, data.length, true);
      local.setUint16(26, name.length, true);
      parts.push(new Uint8Array(local.buffer), name, data);
      let entry = new DataView(new ArrayBuffer(46));
      entry.setUint32(0, 0x02014b50, true);
      entry.setUint16(4, 20, true);
      entry.setUint16(6, 20, true);
      entry.setUint16(8, 0x0800, true);
      entry.setUint16(14, 0x0021, true);
      entry.setUint32(16, crc, true);
      entry.setUint32(20, data.length, true);
      entry.setUint32(24, data.length, true);
      entry.setUint16(28, name.length, true);
      entry.setUint32(42, offset, true);
      directory.push(new Uint8Array(entry.buffer), name);
      offset += 30 + name.length + data.length;
    });
    let directorySize = directory.reduce((total, part) => total + part.length, 0);
    let end = new DataView(new ArrayBuffer(22));
    end.setUint32(0, 0x06054b50, true);
    end.setUint16(8, files.length, true);
    end.setUint16(10, files.length, true);
    end.setUint32(12, directorySize, true);
    end.setUint32(16, offset, true);
    let all = [...parts, ...directory, new Uint8Array(end.buffer)];
    let zip = new Uint8Array(offset + directorySize + 22);
    let position = 0;
    all.forEach(part => {
      zip.set(part, position);
      position += part.length;
    });
    return zip;
  }

  //rows are only collected here and written by getExcelPostamble, since an HTML table in any row widens its column for all rows
  getExcelRow(values) {
    this.excelRows.push(values);
    return '';
  }

  escapeExcelXmlValue(value) {
    if (value == undefined || value == null) {
      return "";
    }
     value = value + "";
    if (value.length > 1 && value[0] == '"' && value[value.length - 1] == '"') {
     value = value.substring(1, value.length - 1).replace(/""/g, '"');
     }
   return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
  }

  //a plain value is one cell filling its whole area; an HTML value is laid out by htmlToExcelLayout
  getExcelLayout(value) {
    let text = (value == undefined || value == null) ? "" : value + "";
    if (!this.htmlValuePattern.test(text)) {
      return { width: 1, height: 1, cells: [{ row: 0, col: 0, fillWidth: true, fillHeight: true, data: this.escapeExcelXmlValue(value), style: {} }] };
    }
    return this.htmlToExcelLayout(text);
  }

  //HTML is laid out top to bottom: text becomes one rich text cell across the field, a table becomes real cells
  htmlToExcelLayout(html) {
    let body = new DOMParser().parseFromString(html, "text/html").body;
    let skipTags = ["SCRIPT", "STYLE", "TEMPLATE", "NOSCRIPT", "SVG", "IFRAME", "VIDEO", "AUDIO", "OBJECT", "EMBED", "CANVAS"];
    let blockTags = ["P", "DIV", "LI", "TR", "TABLE", "UL", "OL", "DL", "DT", "DD", "H1", "H2", "H3", "H4", "H5", "H6", "BLOCKQUOTE", "PRE", "HR",
      "SECTION", "ARTICLE", "HEADER", "FOOTER", "MAIN", "NAV", "ASIDE", "FIGURE", "FIGCAPTION", "ADDRESS", "CAPTION", "CENTER", "FIELDSET", "LEGEND", "DETAILS", "SUMMARY", "FORM"];
    let headingSizes = [24, 18, 14, 12, 10, 8];
    let fontTagSizes = [8, 10, 12, 14, 18, 24, 36];
    let keywordSizes = { "xx-small": 7, "x-small": 8, "small": 10, "medium": 12, "large": 14, "x-large": 18, "xx-large": 24 };
    let horizontalAligns = { "left": "Left", "start": "Left", "center": "Center", "right": "Right", "end": "Right", "justify": "Justify" };
    let cells = [];
    let rowOffset = 0;
    let width = 1;
    let runs = [];
    let addText = (text, style) => {
      if (!text) {
        return;
      }
      let key = JSON.stringify(style);
      let last = runs[runs.length - 1];
      if (last && last.key == key) {
        last.text += text;
      } else {
        runs.push({ text: text, style: style, key: key });
      }
    };
    let lastChar = () => runs.length == 0 ? "\n" : runs[runs.length - 1].text.slice(-1);
    let trimEnd = () => {
      while (runs.length > 0) {
        let last = runs[runs.length - 1];
        last.text = last.text.replace(/\s+$/, "");
        if (last.text) {
          break;
        }
        runs.pop();
      }
    };
    let escapeText = (text) => text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    let runsToXml = (list) => list.map(run => {
      let style = run.style;
      //a formatted run always names its size and font, otherwise LibreOffice falls back to a serif font for it
      let properties = run.key == "{}" ? '' : (style.bold ? '<b/>' : '') + (style.italic ? '<i/>' : '') + (style.strike ? '<strike/>' : '') + (style.underline ? '<u/>' : '')
        + (style.position ? '<vertAlign val="' + (style.position == 'Sub' ? 'subscript' : 'superscript') + '"/>' : '')
        + '<sz val="' + (style.size || 11) + '"/>' + (style.color ? '<color rgb="FF' + style.color.slice(1) + '"/>' : '')
        + '<rFont val="' + this.escapeExcelXmlValue(style.face || 'Calibri') + '"/>';
      return '<r>' + (properties ? '<rPr>' + properties + '</rPr>' : '') + '<t xml:space="preserve">' + escapeText(run.text) + '</t></r>';
    }).join("");
    //text formatted the same throughout is written as plain text with the formatting as the cell's font; only mixed formatting is written as rich text runs
    let toCellData = (list) => {
      let text = list.map(run => run.text).join("");
      let fontSize = Math.max(11, ...list.map(run => run.style.size || 11));
      let linkRun = list.find(run => run.style.href);
      let link = linkRun ? linkRun.style.href : "";
      let visible = list.filter(run => run.text.trim());
      if (visible.every(run => run.key == visible[0].key)) {
        let { href, ...font } = visible.length > 0 ? visible[0].style : {};
        return { text: text, fontSize: fontSize, data: escapeText(text), rich: false, link: link, font: font };
      }
      return { text: text, fontSize: fontSize, data: runsToXml(list), rich: true, link: link, font: {} };
    };
    //text before, between or after tables becomes one cell across the field
    let flushText = () => {
      trimEnd();
      if (runs.length > 0) {
        cells.push({ row: rowOffset, col: 0, colspan: 1, rowspan: 1, fillWidth: true, style: {}, ...toCellData(runs) });
        rowOffset++;
      }
      runs = [];
    };

    //inCell: inside a table cell, where a nested table is flattened to text; pre: whitespace is kept as written
    let walk = (node, style, inCell, pre) => {
      if (node.nodeType == 3) {
        let text = node.textContent;
        if (pre) {
          text = text.replace(/\r\n?/g, "\n").replace(/\t/g, "    ");
        } else {
          text = text.replace(/[ \t\r\n\f]+/g, " ");
          if (lastChar() == " " || lastChar() == "\n") {
            text = text.replace(/^ /, "");
          }
        }
        addText(text.replace(/ /g, " "), style);
        return;
      }
      if (node.nodeType != 1) {
        return;
      }
      let tag = node.tagName.toUpperCase();
      if (skipTags.indexOf(tag) > -1) {
        return;
      }
      if (tag == "IMG") {
        let alt = (node.getAttribute("alt") || "").trim();
        addText(alt ? "[Image: " + alt + "]" : "[Image]", style);
        return;
      }
      let css = node.style || {};
      let isFont = tag == "FONT";
      let href = tag == "A" ? (node.getAttribute("href") || "").trim() : "";
      let isLink = /^(https?:|mailto:|tel:)/i.test(href);
      let isPre = pre || tag == "PRE" || (css.whiteSpace || "").indexOf("pre") == 0;
      let childStyle = { ...style };

      if (["B", "STRONG", "TH", "H1", "H2", "H3", "H4", "H5", "H6"].indexOf(tag) > -1 || css.fontWeight == "bold" || css.fontWeight == "bolder" || parseInt(css.fontWeight) >= 600) {
        childStyle.bold = true;
      } else if (css.fontWeight == "normal" || css.fontWeight == "lighter" || parseInt(css.fontWeight) < 600) {
        delete childStyle.bold;
      }
      if (["I", "EM", "CITE", "VAR", "DFN", "ADDRESS"].indexOf(tag) > -1 || css.fontStyle == "italic" || css.fontStyle == "oblique") {
        childStyle.italic = true;
      } else if (css.fontStyle == "normal") {
        delete childStyle.italic;
      }
      if (["U", "INS"].indexOf(tag) > -1 || isLink || (css.textDecorationLine || "").indexOf("underline") > -1) {
        childStyle.underline = true;
      }
      if (["S", "STRIKE", "DEL"].indexOf(tag) > -1 || (css.textDecorationLine || "").indexOf("line-through") > -1) {
        childStyle.strike = true;
      }
      if (tag == "SUB" || css.verticalAlign == "sub") {
        childStyle.position = "Sub";
      } else if (tag == "SUP" || css.verticalAlign == "super") {
        childStyle.position = "Sup";
      }

      if (isLink) {
        childStyle.color = "#0563C1";
        childStyle.href = href;
      }
      let color = this.toExcelColor(css.color || (isFont ? node.getAttribute("color") : ""));
      if (color) {
        childStyle.color = color;
      }

      if (["CODE", "KBD", "SAMP", "TT", "PRE"].indexOf(tag) > -1) {
        childStyle.face = "Courier New";
      }
      let face = css.fontFamily || (isFont ? node.getAttribute("face") : "");
      if (face) {
        childStyle.face = face.split(",")[0].replace(/["']/g, "").trim();
      }

      let baseSize = style.size || 11;
      let fontTagSize = isFont ? (node.getAttribute("size") || "").trim() : "";
      if (/^H[1-6]$/.test(tag)) {
        childStyle.size = headingSizes[parseInt(tag[1]) - 1];
      } else if (tag == "SMALL") {
        childStyle.size = Math.round(baseSize * 0.83);
      } else if (tag == "BIG") {
        childStyle.size = Math.round(baseSize * 1.2);
      } else if (fontTagSize) {
        let fontTagIndex = (/^[+-]/.test(fontTagSize) ? 3 : 0) + parseInt(fontTagSize);
        if (fontTagIndex > 0) {
          childStyle.size = fontTagSizes[Math.min(fontTagIndex, 7) - 1];
        }
      }
      let size = css.fontSize || "";
      if (size.endsWith("px")) {
        childStyle.size = Math.round(parseFloat(size) * 0.75);
      } else if (size.endsWith("pt")) {
        childStyle.size = parseFloat(size);
      } else if (size.endsWith("rem")) {
        childStyle.size = Math.round(parseFloat(size) * 12);
      } else if (size.endsWith("em")) {
        childStyle.size = Math.round(parseFloat(size) * baseSize);
      } else if (size.endsWith("%")) {
        childStyle.size = Math.round(parseFloat(size) * baseSize / 100);
      } else if (keywordSizes[size]) {
        childStyle.size = keywordSizes[size];
      }

      let isBlock = blockTags.indexOf(tag) > -1;
      if (tag == "BR" || (isBlock && lastChar() != "\n")) {
        addText("\n", {});
      }

      //table: every HTML cell becomes a sheet cell at its grid position, colspan/rowspan become merges
      if (tag == "TABLE" && !inCell) {
        flushText();
        if (node.caption) {
          walk(node.caption, { ...childStyle, bold: true }, false, isPre);
          flushText();
        }
        let bordered = node.getAttribute("border") != "0";
        let rowCount = node.rows.length;
        let occupied = {};
        Array.from(node.rows).forEach((row: any, rowIndex) => {
          let col = 0;
          Array.from(row.cells).forEach((cell: any) => {
            while (occupied[rowIndex + "," + col]) {
              col++;
            }
            let colspan = Math.max(cell.colSpan || 1, 1);
            let rowspan = Math.min(Math.max(cell.rowSpan || 1, 1), rowCount - rowIndex);
            for (let r = 0; r < rowspan; r++) {
              for (let c = 0; c < colspan; c++) {
                occupied[(rowIndex + r) + "," + (col + c)] = true;
              }
            }
            walk(cell, childStyle, true, isPre);
            trimEnd();
            let cellCss = cell.style || {};
            let rowCss = row.style || {};
            let align = (cellCss.textAlign || cell.getAttribute("align") || rowCss.textAlign || row.getAttribute("align") || (cell.tagName == "TH" ? "center" : "")).toLowerCase();
            let valign = (cellCss.verticalAlign || cell.getAttribute("valign") || row.getAttribute("valign") || "middle").toLowerCase();
            let background = this.toExcelColor(cellCss.backgroundColor || cell.getAttribute("bgcolor") || rowCss.backgroundColor || row.getAttribute("bgcolor"));
            let cellStyle: any = { border: bordered, wrap: true, vertical: valign == "top" ? "Top" : valign == "bottom" ? "Bottom" : "Center" };
            if (horizontalAligns[align]) {
              cellStyle.horizontal = horizontalAligns[align];
            }
            if (background) {
              cellStyle.background = background;
            }
            cells.push({ row: rowOffset + rowIndex, col: col, colspan: colspan, rowspan: rowspan, style: cellStyle, ...toCellData(runs) });
            runs = [];
            col += colspan;
            width = Math.max(width, col);
          });
        });
        rowOffset += rowCount;
        return;
      }

      if (inCell && (tag == "TD" || tag == "TH") && node.previousElementSibling && runs.length > 0) {
        addText(" | ", style);
      }
      if (tag == "LI") {
        let parent = node.parentElement;
        let depth = 0;
        for (let element = parent; element; element = element.parentElement) {
          if (element.tagName == "UL" || element.tagName == "OL") {
            depth++;
          }
        }
        let marker = "• ";
        if (parent && parent.tagName == "OL") {
          marker = ((parent.start || 1) + Array.from(parent.children).filter((child: any) => child.tagName == "LI").indexOf(node)) + ". ";
        }
        addText("    ".repeat(Math.max(depth - 1, 0)) + marker, {});
      }
      if (tag == "HR") {
        addText("─".repeat(20), {});
      }
      if (tag == "Q") {
        addText('"', style);
      }

      node.childNodes.forEach(child => walk(child, childStyle, inCell, isPre));

      if (tag == "Q") {
        addText('"', style);
      }
      if (isLink && href.replace(/^(mailto|tel):/i, "") != node.textContent.trim()) {
        addText(" (" + href + ")", style);
      }
      if (isBlock && lastChar() != "\n") {
        addText("\n", {});
      }
    };
    walk(body, {}, false, false);
    flushText();

    if (cells.length == 0) {
      cells.push({ row: 0, col: 0, fillWidth: true, fillHeight: true, data: "", rich: false, style: {} });
      rowOffset = 1;
    }
    let lastCell = cells[cells.length - 1];
    if (lastCell.fillWidth) {
      lastCell.fillHeight = true;
    }
    return { width: width, height: rowOffset, cells: cells };
  }

  //any CSS color (name, hex, rgb, hsl) to the #RRGGBB form SpreadsheetML accepts
  toExcelColor(color) {
    if (!color) {
      return "";
    }
    if (!this.excelColorContext) {
      this.excelColorContext = document.createElement("canvas").getContext("2d");
    }
    if (!this.excelColorContext) {
      return "";
    }
    this.excelColorContext.fillStyle = "transparent";
    this.excelColorContext.fillStyle = color;
    let hex = this.excelColorContext.fillStyle;
    return /^#[0-9a-f]{6}$/i.test(hex) ? hex.toUpperCase() : "";
  }


  downloadCSVFromJson = (filename, arrayOfJson) => {
    // convert JSON to CSV
    const replacer = (key, value) => value === null ? '' : value // specify how you want to handle null values here
    const header = Object.keys(arrayOfJson[0])
    let csv = arrayOfJson.map(row => header.map(fieldName =>
      JSON.stringify(row[fieldName], replacer)).join(','))
    csv.unshift(header.join(','))
    csv = csv.join('\r\n')

    // Create link and download
    this.utilService.downloadFile(csv, 'text/csv', filename);
  };
  isDataLake(args) {
    return args && args.includes("db_type:11")
  }
  isChunkDownload(printInfo){
    if(printInfo.isChunkDownload != undefined && printInfo.isChunkDownload){
      return true;
    }
    return false;
  }
  formatData(res, printInfo, fileName,callback = null) {
    if(printInfo.isChunkDownload == undefined){
      printInfo.isChunkDownload = false;
    }
    if(printInfo.isLastFile == undefined){
      printInfo.isLastFile = false;
    }
    if(printInfo.isFirstFile == undefined){
      printInfo.isFirstFile = false;
    }
    if(printInfo.type != undefined && printInfo.type == "print"){
      printInfo = this.createPrintInfo(printInfo);
    }
    this.formatDataFn(res, printInfo, fileName,callback)
  }

  formatDataFn(res, printInfo, fileName,callback = null) {
    if (res != "") {
      var legacyDownload = true;
      if(printInfo.legacyDownload != undefined){
        legacyDownload = printInfo.legacyDownload;
      }
      var totoalDataSize:any = 0;
      if(printInfo.totalCount != undefined){
        totoalDataSize = printInfo.totalCount;
      }
      if (typeof Worker !== 'undefined' && !legacyDownload && totoalDataSize > this.WORKER_THRESHOLD) {
        var worker;
       
          worker = new Worker(new URL('../workers/download.worker', import.meta.url));
          printInfo.worker = worker;
             
        console.log("===== DOWNLOAD STARTING WITH WORKER===== ");
        console.log("===== WORKER REGISTRATION SUCCESSFULL===== ");
        
        this.formatDataInternal(res, printInfo, fileName,legacyDownload,worker,callback) 
      }else{
        this.loader.showSpinner();
        this.formatDataInternal(res, printInfo, fileName,legacyDownload,false,callback) 
      }
     
    }else {
      console.error("CSV Data not found");
      this.alerts.error("cffe");
    }
  }
  calculatePercentage(part, whole) {
    let percentage = (part / whole) * 100;
    return Math.round(percentage); // Round the percentage to the nearest whole number
  }
  formatDataInternal(res, printInfo, fileName,legacyDownload,worker,callback = null) {
    console.log("FORMAT INTERNAL XLS => ", printInfo.isCurrentXls);
    if (res != "") {
      var gridInfo = printInfo.gridInfo;
      var action = printInfo.action || "download";
      //removing last complete empty row
      if (res[res.length - 1] == '\n') {
        res = res.substring(0, res.length - 1);
      }
      var finalData = [];
      var totoalDataSize:any = 0;
      var keyInfo = [];
        
      if(!worker){
        finalData = this.CSVToArray(res);
        keyInfo = finalData.shift();
        if(this.isChunkDownload(printInfo)){
          totoalDataSize = "Processing";         
        }else{
          totoalDataSize = finalData.length;
        }
        res = "";//releasing the memory        
      }else{   
        console.log("===== WORKER CSV DATA SENDING ===== ");    
        worker.postMessage({threshold:this.WORKER_THRESHOLD,csvContent:res});
        console.log("===== WORKER CSV DATA SENDING SUCCESS ===== ");    
        res = "";//releasing the memory  
        totoalDataSize = "Processing";
      }
      if(printInfo.totalCount != undefined && printInfo.totalCount != "0"){
        totoalDataSize = printInfo.totalCount;
      }
      
      
      
      if (totoalDataSize) {
        
        
        if(printInfo.frontendSorting != undefined && legacyDownload){
          let colI = printInfo.gridInfo.findIndex(x => x.name == printInfo.frontendSorting.key)
          if(colI>-1){
            let dataIndexBE = keyInfo.findIndex(x => x == printInfo.frontendSorting.key);
            printInfo["frontendSorting"]  = JSON.parse(JSON.stringify(printInfo.frontendSorting));
            printInfo["frontendSorting"]["key"] = dataIndexBE;
            printInfo["frontendSorting"]["value"] = printInfo["frontendSorting"]["value"] == 'asc' ? '1' : '0';
            finalData = this.utilService.sortData(finalData,printInfo.frontendSorting,printInfo.gridInfo[colI]);
          }
          
        }
        this.config.total = totoalDataSize;
        if(!this.isChunkDownload(printInfo) || (this.isChunkDownload(printInfo) && printInfo.isFirstFile)){
          var dialog = this.dialogService.open(DownloadInfoComponent, {config:this.config,data:{showLoader:(worker)?false:true}});
          printInfo.dialog = dialog;
        }
        

        if (document.getElementById('download_records')) {
          document.getElementById('download_records').textContent = this.config.total;
        }

        setTimeout(() => {
          // NProgress.configure({ parent: '#download_area' });            
          // NProgress.set(0.0); 
          // NProgress.inc(); 
          var start = Date.now();
          console.log("===== CSV DOWNLOAD DATA FOUND===== ", totoalDataSize);
          console.log("===== CSV DOWNLOAD COLUMN FOUND===== ", gridInfo.length);
          
          if (action != "print" && !this.appService.checkNativeApp()) {
            if(this.isChunkDownload(printInfo) && printInfo.fileStream != undefined){
              var fileStream = printInfo.fileStream;
              var writer = printInfo.writer;
              var encode = printInfo.encode;
            }else{
              if(printInfo.isCurrentXls){
                  fileName = fileName.replace(".csv",".xlsx");
                }
              var fileStream = streamSaver.createWriteStream("formatted_" + fileName)
              var writer = fileStream.getWriter();
              var encode = TextEncoder.prototype.encode.bind(new TextEncoder);

              if(printInfo.isCurrentXls){
                writer.write(encode(this.getExcelPreamble()));
                }

              if(this.isChunkDownload(printInfo)){
                printInfo.fileStream = fileStream;
                printInfo.writer = writer;
                printInfo.encode = encode;
              }
              
            }
          } else {
            window.URL = window.webkitURL || window.URL;
            var csvContent = "";
            if(printInfo.isCurrentXls){
              fileName = fileName.replace(".csv",".xlsx");
              csvContent += this.getExcelPreamble();
            }
          }


         if(worker){
          var totalWorkerDataGot = 0;
          
          console.log("===== WORKER GETTING DATA ===== ");    
          worker.postMessage({getData:true});
          worker.onmessage = ({ data }) => {
            if(data.chunkData != undefined){
              
              var keyInserted = false
              if(totalWorkerDataGot === 0){
                
                keyInfo = data.chunkData.shift();//for first time the first element will be key of the csv
              }else{
                keyInserted = true;
              }

              
              if(this.isChunkDownload(printInfo) && printInfo.isFirstFile != undefined && !printInfo.isFirstFile){
                keyInserted = true;
              }
              if(printInfo.totalWorkerDataGot != undefined){
                totalWorkerDataGot = printInfo.totalWorkerDataGot;
              }
             
              console.log("===== WORKER DATA RECIEVE ===== ",data.chunkData.length);   
              csvContent += this.loopDataAndWrite(data.chunkData,gridInfo,printInfo,keyInfo,action,writer,csvContent,encode,keyInserted);
              totalWorkerDataGot += data.chunkData.length;
              printInfo.totalWorkerDataGot = totalWorkerDataGot;
              if (document.getElementById('total_records')) {
                document.getElementById("total_records").parentNode.style.display = 'block';
                document.getElementById('total_records').textContent = totalWorkerDataGot;
                let percentage = this.calculatePercentage(totalWorkerDataGot,totoalDataSize);
                document.getElementById("total_records_progress").children[0].style.width = percentage+"%";
                document.getElementById("total_records_progress").children[0].textContent = percentage+"%";
              }
              worker.postMessage({getData:true});
            }
            if(data.terminate != undefined){
              
              worker.terminate();
              
              console.log("===== WORKER TERMINATED===== Total Data SENT BY WORKER",totalWorkerDataGot);   
              if(totalWorkerDataGot != totoalDataSize){
                console.error("WORKER SEND MISMATCHED DATA")
              }
              this.formateInternal2(finalData,gridInfo,printInfo,dialog,action,writer,encode,csvContent,start,fileName)
              if(this.isChunkDownload(printInfo)){
                if(callback){
                  callback(printInfo);
                 }
              }
            }
            
          };
          if(!this.isChunkDownload(printInfo)){
            if(callback){
              callback(printInfo);
             }
          }
         }else{
          var keyInserted  = false;
          if(this.isChunkDownload(printInfo) && printInfo.isFirstFile != undefined && !printInfo.isFirstFile){
            keyInserted = true;
          }
          csvContent += this.loopDataAndWrite(finalData,gridInfo,printInfo,keyInfo,action,writer,csvContent,encode,keyInserted)
          ;
          this.formateInternal2(finalData,gridInfo,printInfo,dialog,action,writer,encode,csvContent,start,fileName)
          if(callback){
            callback(printInfo);
           }
         }
        
          //NProgress.done(true);
        }, 500);

      } else {
        this.config.loading = false;
        this.loader.hideSpinner();
        console.error("CSV Data not found after parsing");
        this.alerts.error("cffe");
      }
    } else {
      this.config.loading = false;
      this.loader.hideSpinner();
      console.error("CSV Data not found");
      this.alerts.error("cffe");
    }
  }
  formatCSV(obj,callback = null) {
    try {
      var params: any = (Object as any).fromEntries(new URLSearchParams(obj.data.resource));
      if (params.resource != undefined && params.resource) {
        var summaryInfo = {};
        var resource = JSON.parse(atob(params.resource));
        var gridInfo = JSON.parse(atob(resource.gridInfo));
        var downloadSumary = (resource.download_summary != undefined)?resource.download_summary:false;
        var excludeFields = (resource.excludeFields != undefined)?resource.excludeFields:false;
        if(resource.amount != undefined){
          try{
            summaryInfo = JSON.parse(atob(resource.amount));
          }catch(e){

          }
        }
        if (gridInfo && !this.config.loading) {
          var args = (resource != undefined && resource.args != undefined) ? resource.args : "";
          console.log("gridInfo===>", gridInfo);
          resource["isCurrentXls"] = obj.isCurrentXls;
          this.loader.showSpinner();
          this.config.loading = true;
          this.config.total = 0;
          this.config.done = 0;
          var legacyDownload = true;
          if(obj.actionType != undefined && obj.actionType.use_sw != undefined){
            legacyDownload = false;
          }
          var url = obj.data.url;
          if(url.indexOf(",")>-1){
            url = url.split(",");
            obj.isChunkDownload = true;
            obj.isFirstFile = true;
            this.loopFileAndFormat(url,downloadSumary,summaryInfo,gridInfo,args,obj,legacyDownload,excludeFields,callback);
          }else{
            console.log("FORMAT CSV XLS => ", obj.isCurrentXls);
            this.getFileAndFormat(url,downloadSumary,summaryInfo,gridInfo,args,obj,legacyDownload,excludeFields,()=>{
              this.loader.hideSpinner();
              this.config.loading = false;
              NProgress.done(true);
              if(callback){
                callback();
              }
              this.adr.tick()
            })
          }          
        } else {
          console.error("Another request is currently being processed. Please wait and try again.");
          this.alerts.error("dwninprogress");
        }
      } else {
        console.error("Error parsing format data to query params");
        this.alerts.error("cffe");
      }

    } catch (e) {
      console.error("CSV Data parse error", e);
      this.alerts.error("cffe");
    }
  }
  loopFileAndFormat(urlList,downloadSumary,summaryInfo,gridInfo,args,obj,legacyDownload,excludeFields,callback){
    var singleUrl = urlList.shift(); 
    if(urlList.length == 0){
      obj.isLastFile = true;
    }
    this.getFileAndFormat(singleUrl,downloadSumary,summaryInfo,gridInfo,args,obj,legacyDownload,excludeFields,(printInfo)=>{
      if(urlList.length>0){
          if(printInfo.fileStream != undefined){
              var keys = ["fileStream","writer","encode","dialog","totalWorkerDataGot"];
              for (let i = 0; i < keys.length; i++) {
                if(printInfo[keys[i]] != undefined){
                  obj[keys[i]] = printInfo[keys[i]];
                }        
              }
          }
          obj["isFirstFile"] = false;
        this.loopFileAndFormat(urlList,downloadSumary,summaryInfo,gridInfo,args,obj,legacyDownload,excludeFields,callback);
      }else{
        this.loader.hideSpinner();
        this.config.loading = false;
        NProgress.done(true);
        if(callback){
          callback();
        }
        this.adr.tick();
        if(jQuery('ngx-spinner div').length>0){
          jQuery('ngx-spinner div')[0].remove()
        }
      }
    }) 
  }
  getFileAndFormat(url,downloadSumary,summaryInfo,gridInfo,args,obj,legacyDownload,excludeFields,callback){
    console.log("GET FILE XLS => ", obj.isCurrentXls);
    this.baseService.getFileByUrl(url, false, 'text').subscribe(res => {
      var printInfo:any = { downloadSumary:downloadSumary,summaryInfo:summaryInfo,gridInfo: gridInfo, action: "download", args: args,totalCount:obj.data.data_count,legacyDownload:legacyDownload,excludeFields:excludeFields, isCurrentXls : obj.isCurrentXls};
      
      var keys = ["isChunkDownload","isLastFile","isFirstFile","fileStream","writer","encode","dialog","totalWorkerDataGot"];
      for (let i = 0; i < keys.length; i++) {
        if(obj[keys[i]] != undefined){
          printInfo[keys[i]] = obj[keys[i]];
        }        
      }

      if(obj != undefined && obj.data != undefined){
        if(obj.data.type != undefined){
          printInfo.type = obj.data.type;
        }
        if(obj.data.type != undefined){
          printInfo.type = obj.data.type;
        }
        if(obj.data.post_obj != undefined){
          printInfo.postObj = obj.data.post_obj;
        }
      }

      this.formatData(res, printInfo, obj.data.file_name,callback);
      this.config.loading = false;
      NProgress.done(true);
    }, (error) => {
      this.loader.hideSpinner();
      this.alerts.error('cffe');
      NProgress.done(true);
      this.config.loading = false;
    });
  }

  getUniqueName(gridInfo, gridObject, uniqueHeadings) {
    let newname = gridObject.name;
    gridInfo.forEach((element, index) => {
      if (element.name == gridObject.name && element.heading == gridObject.heading) {
        if (!uniqueHeadings.includes(element.name)) {
          uniqueHeadings.push(element.name)
        } else {
          newname = newname + "_" + index;
        }
      }
    });
    return newname;
  }

  formateInternal2(finalData,gridInfo,printInfo,dialog,action,writer,encode,csvContent,start,fileName){
     /**************************** SUMMARY INSERTION ************************/
     if((!printInfo.isChunkDownload || (printInfo.isChunkDownload && printInfo.isLastFile)) && printInfo.downloadSumary != undefined && printInfo.downloadSumary && printInfo.summaryInfo != undefined && Array.isArray(printInfo.summaryInfo) && printInfo.summaryInfo.length>0){
      for (let index = 0; index < printInfo.summaryInfo.length; index++) {
        const summary = printInfo.summaryInfo[index];
        
          if(summary.key_name != undefined || summary.key != undefined){
            if (action != "print"  && !this.appService.checkNativeApp()) {
              if(index==0){
                writer.write(encode('\r\n'));
              }
              
              writer.write(encode(summary.key_name));
              writer.write(encode('\r\n'));
            } else {
              if(index==0){
                csvContent += '\r\n';
              }
              csvContent += summary.key_name;
              csvContent += '\r\n';
            }
            var summaryRow = [];
            if(summary.summary_array != undefined  && Array.isArray(summary.summary_array) && summary.summary_array.length>0){
              for (let index = 0; index < summary.summary_array.length; index++) {
                const singleSummary = summary.summary_array[index];
                if(singleSummary.key != undefined && singleSummary.value != undefined){
                  summaryRow.push(singleSummary.key);
                  summaryRow.push(singleSummary.value);
                }
              }
            }else{
              if(summary.key != undefined && summary.value != undefined){
                summaryRow.push('"'+summary.key+'"');
                summaryRow.push('"'+summary.value+'"');
              }
            }
            if (action != "print"  && !this.appService.checkNativeApp()) {
              if(printInfo.isCurrentXls){
                writer.write(encode(this.getExcelRow(summaryRow)));
              }else{
                writer.write(encode(summaryRow.toString()));
                writer.write(encode('\r\n'));
              }
            } else {      
              if(printInfo.isCurrentXls){
                  csvContent += this.getExcelRow(summaryRow);
              }else{
                  csvContent += summaryRow.toString();
                  csvContent += '\r\n';
              }
            }
          }
      }
    }
    /**************************** SUMMARY INSERTION ************************/

    
  
    let timeTaken = Date.now() - start;
    console.log("===== CSV DOWNLOAD WRITING TIME TAKEN===== " + timeTaken + " milliseconds");
    if (action != "print"  && !this.appService.checkNativeApp()) {
      if((!printInfo.isChunkDownload || (printInfo.isChunkDownload && printInfo.isLastFile))){
        this.loader.hideSpinner();
        if(printInfo.isCurrentXls){
          writer.write(this.getExcelPostamble());
          }
        writer.close();
      }     
    } else {
      var contentType = printInfo.isCurrentXls
      ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      : 'text/csv;charset=utf-8;';
      if(printInfo.isCurrentXls){
         csvContent = this.getExcelPostamble();
         fileName = fileName.replace(".csv",".xlsx");
        }
      var csvFile = new Blob([csvContent], { type: contentType });
      var reader = new FileReader();

      var file = new File([csvFile], fileName)
      if (action != "print" ){
        //its native file downloading for CSV
        if((!printInfo.isChunkDownload || (printInfo.isChunkDownload && printInfo.isLastFile))){
          this.utilService.nativeFileHandling(csvFile, contentType, fileName);
        }
      }else{
        const formData = new FormData();
        formData.append('file', file);
        formData.append('fileName', fileName);
        formData.append('gridInfo', btoa(unescape(encodeURIComponent(JSON.stringify(printInfo["postObj"])))));
        setTimeout(()=>{
          this.loader.showSpinner();
          if(printInfo && printInfo.postObj && printInfo.postObj.print_all && printInfo.postObj.template == "grid"){
            printInfo["resource"] = printInfo.postObj._currentResource+'/print_async_all';
            this.baseService.upload(formData, "printengine", printInfo["resource"], csvContent).subscribe(
              (data: any) => {
                this.loader.hideSpinner();
              }, error => {
                console.log(error);
                this.alerts.error(error);
                this.loader.hideSpinner();
              });
          } else {
            this.baseService.upload(formData, "printengine", printInfo["resource"], csvContent, null, "blob").subscribe(
              (data: any) => {
                this.loader.hideSpinner();
                //pdf type is hardcoded
                this.utilService.downloadFile(data, 'application/pdf', fileName.replace(".csv", ".pdf"));
              }, error => {
                console.log(error);
                this.alerts.error(error);
                this.loader.hideSpinner();
              });
          }
        })
        
      }
     
    }

    finalData = [];//releaseing the memory
    gridInfo = [];//releaseing the memory
    if(!this.isChunkDownload(printInfo) || (this.isChunkDownload(printInfo) && printInfo.isLastFile)){
      if(printInfo.dialog != undefined){
        printInfo.dialog.close();
      }else{
        dialog.close();
      }
      
      this.loader.hideSpinner();
    }
    this.adr.tick();
  }

  loopDataAndWrite(finalData,gridInfo,printInfo,keyInfo,action,writer,csvContent,encode,keyInserted){
    let finalArray = [];
    var j = 0;
    for (let dataC of finalData) {
      let excelItem = [];
      let excelHeadings = [];
      var i = 0;
      var item = {};
      for (let k of dataC) {
        if (keyInfo[i] != undefined) {
          if (k != undefined && k.indexOf('"') > -1) {
            k = k.replace(/"/g, '""');
          }
          item[keyInfo[i]] = k;
        }
        i++;
      }
      finalData[j] = [];//releasing the memory
      j++;
      let finalItem = [];
      let finalHeadings = [];
      let uniqueHeadings = [];
      for (let c of gridInfo) {
        /****************EXCLUDE FIELDS **************/
          if(printInfo.excludeFields != undefined && printInfo.excludeFields){
            if(c.name != undefined && printInfo.excludeFields.indexOf(c.name)>-1){
              continue;
            }
          }
        /****************EXCLUDE FIELDS **************/
        if (!keyInserted) {
          /**************** HEADING GENERATION ************* */
          if (c.map != undefined && c.map == "") {
            delete c.map;
          }
          if (c.format != undefined && c.format != "") {
            if(c.print_format){
              try {
                var format = atob(c.print_format);
                c.format = format;
              } catch (e) {
                console.error(e, "Parse error", c.format)
              }
            }
            else{
              try {
                var format = atob(c.format);
                c.format = format;
              } catch (e) {
                console.error(e, "Parse error", c.format)
              }
            }
          }
          if (c.heading != undefined) {
            if (action != "print") {
                   finalHeadings.push('"' + decodeURIComponent(c.heading) + '"');
                   excelHeadings.push(decodeURIComponent(c.heading));      
            } else {
              var hname = this.getUniqueName(gridInfo, c, uniqueHeadings);
              if (hname != undefined) {
                hname = hname.replaceAll(",", "_");
              }
              finalHeadings.push('"' + decodeURIComponent(hname) + '"');
            }
          } else {
            finalHeadings.push("")
          }
          /**************** HEADING GENERATION ************* */
        }
        var v = "";
        try {
          if (this.isDataLake(printInfo.args)) {
            if(c.format != undefined && c.format){
              if(printInfo.excludeFields != undefined && printInfo.excludeFields){
                c.excludeFields = printInfo.excludeFields;
              }
            }
            this.utilService.removeObjectLeterSenstivity(item, c.name);
          }
          v = this.sanitizeCsvValue(this.utilService.getValue(item, c, true));
        } catch (e) {
          console.error("error converting value==>", c, e);
        }

        if (v) {
          if(v == undefined){
              v = "";
            }
            if(typeof v != 'string'){
              v = v+"";
            }
            if (c.isFrontend)
                finalItem.push('"' + v.replace(/"/g, '""') + '"');
            else
                finalItem.push('"' + v + '"');
          excelItem.push(v);
        } else {
          finalItem.push("");
          excelItem.push("");
        }
      }
      if (!keyInserted) {
        //finalArray.push(finalHeadings);
        if (action != "print"  && !this.appService.checkNativeApp()) {

            if(printInfo.isCurrentXls){
                 writer.write(encode(this.getExcelRow(excelHeadings)));
            }else{
                writer.write(encode(finalHeadings.toString()));
                writer.write(encode('\r\n'));
              }
        } else {
           if(printInfo.isCurrentXls){
                csvContent += this.getExcelRow(excelHeadings);
           }else{
                csvContent += finalHeadings.toString();
                csvContent += '\r\n';
           }
        }

        console.log("===== CSV DOWNLOAD WRITING HEADERS===== ");

        keyInserted = true;
      }
      if (action != "print"  && !this.appService.checkNativeApp()) {
        if(printInfo.isCurrentXls){
            writer.write(encode(this.getExcelRow(excelItem)));
        }else{
             writer.write(encode(finalItem.toString()));
             writer.write(encode('\r\n'));
        } 
      } else {

       if(printInfo.isCurrentXls){
          csvContent += this.getExcelRow(excelItem);
       }else{
          csvContent += finalItem.toString();
          csvContent += '\r\n';
       }
      }
      //finalArray.push(finalItem);

      finalItem = [];//releaseing the memory
      console.log("===== CSV DOWNLOAD WRITING DATA===== ", j);
      this.config.done = j;
    }
    finalData = [];
    console.log("===== CSV DOWNLOAD WRITING DONE===== ", j);
    return csvContent;
  }
  
   sanitizeCsvValue(value: string): string {
    if (value !== undefined && typeof value === "string") {
      const DANGEROUS_PREFIXES = ["=", "+", "-", "@"];
      if (DANGEROUS_PREFIXES.some(prefix => value.startsWith(prefix))) {
        // Prefix with space to break formula injection
        return " " + value;
      }
    }
    return value;
  }

  bulckDownloadAll(obj){
    var url = obj.data.url;
    if(url.indexOf(",")>-1){
      url = url.split(",");
      for (let index = 0; index < url.length; index++) {
        const element = url[index];
        obj.data.url = element;
        this.bulkDownload(obj);
      }
    }else{
      this.bulkDownload(obj);
    }
  }
  bulkDownload(obj) {
    this.baseService.getFileByUrl(obj.data.url, false).subscribe(res => {
      this.printService.handleFileReponse({
        contentType: "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        KeyWithExt: obj.data.file_name
      }, "download", res)
    })
  }

  createPrintInfo(printInfo){
    try{
      if(printInfo.postObj != undefined){
        printInfo.postObjStr = JSON.parse(printInfo.postObj);
        printInfo.args = printInfo.args.replace("xlsx","pdf")
        printInfo.postObj = {};
        printInfo.postObj.gridInfo = btoa(JSON.stringify(printInfo.gridInfo));
        printInfo.postObj.args = printInfo.args;
        printInfo.postObj.gridHeading = printInfo.postObjStr.gridHeading
        printInfo.postObj.template = "grid"
        printInfo.postObj.contentType = "pdf"

        printInfo.action = "print";
        printInfo.actionType = "download";
        printInfo.resource = printInfo.postObjStr.resource;
        printInfo.resourceType = "blob";
      }
      return printInfo;
    }catch(e){
      return printInfo;
    }
    

    return printInfo;
  }
}